import { en } from './en';
import { tr } from './tr';
import { az } from './az';

export const translations = {
  en,
  tr,
  az
};

export const currencySymbols = {
  USD: '$',
  TRY: '₺',
  AZN: '₼'
};

export const currencyNames = {
  USD: 'US Dollar',
  TRY: 'Turkish Lira',
  AZN: 'Azerbaijani Manat'
};
